"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MoonDial;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg"));
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _excluded = ["value", "range", "size", "name", "formatValue", "formatRange", "loading", "onPress", "style", "strokeColour", "mostlyFullColour", "almostEmptyColour", "textColour", "almostEmptyTextColour", "mostlyFullTextColour"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var totalPathLength = 197.49652099609375;

// prevents '0 / 0 = NaN'
function zeroSafety(val) {
  return isFinite(val) ? val : 0;
}
var RATIO_THRESHOLD = 0.25;
function MoonDial(props) {
  var value = props.value,
    range = props.range,
    size = props.size,
    name = props.name,
    formatValue = props.formatValue,
    formatRange = props.formatRange,
    loading = props.loading,
    onPress = props.onPress,
    style = props.style,
    strokeColour = props.strokeColour,
    mostlyFullColour = props.mostlyFullColour,
    almostEmptyColour = props.almostEmptyColour,
    textColour = props.textColour,
    almostEmptyTextColour = props.almostEmptyTextColour,
    mostlyFullTextColour = props.mostlyFullTextColour,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var content = (0, _content.useContent)();
  var ratio = zeroSafety(value / range);
  var hasLoading = props.hasOwnProperty('loading');
  var hasInfinite = value === -1;
  function getTextFill() {
    if (hasLoading && loading) {
      return _styles.colors.trivial;
    } else if (hasInfinite) {
      return mostlyFullTextColour;
    } else if (range > 0 && ratio < RATIO_THRESHOLD) {
      return almostEmptyTextColour;
    } else if (range > 0 && ratio > RATIO_THRESHOLD) {
      return mostlyFullTextColour;
    } else {
      return textColour;
    }
  }
  function handlePress(e) {
    if (hasLoading) {
      if (!loading) {
        if (onPress) onPress(e);
      }
    } else {
      if (onPress) onPress(e);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg["default"], (0, _extends2["default"])({
    viewBox: "0 0 96 96",
    height: JSON.stringify(size),
    width: JSON.stringify(size),
    onClick: handlePress
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
    strokeWidth: "12",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Path, {
    stroke: strokeColour,
    d: "M77.7 77.7C85.3 70.1 90 59.6 90 48 90 24.8 71.2 6 48 6S6 24.8 6 48c0 11.44 4.58 21.8 11.99 29.37"
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Path, {
    stroke: hasLoading && loading ? _styles.colors.subtle : range > 0 && ratio < RATIO_THRESHOLD ? almostEmptyColour : mostlyFullColour,
    strokeDasharray: "".concat(totalPathLength, " ").concat(totalPathLength),
    strokeDashoffset: -(totalPathLength - totalPathLength * (value > range ? value / 100 : zeroSafety(value / range))),
    d: "M77.7 77.7C85.3 70.1 90 59.6 90 48 90 24.8 71.2 6 48 6S6 24.8 6 48c0 11.44 4.58 21.8 11.99 29.37"
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
    textAnchor: "middle",
    fontFamily: 'futura-pt-bold',
    fontWeight: "900"
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "48",
    y: "31",
    fontSize: "10",
    linespacing: "12",
    fill: hasLoading && loading ? _styles.colors.subtle : _styles.colors.focus,
    style: _reactNative.StyleSheet.flatten(style)
  }, loading ? content.common.loading : name), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "48",
    y: hasInfinite ? "56" : "52",
    fontSize: hasInfinite ? "32" : "18",
    linespacing: "24",
    textAnchor: "middle",
    fill: getTextFill(),
    style: _reactNative.StyleSheet.flatten(style)
  }, hasInfinite ? content.common.infinity : formatValue(value)), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "48",
    y: "68",
    fontSize: "10",
    linespacing: "12",
    fill: hasLoading && loading ? _styles.colors.subtle : _styles.colors.trivial,
    style: _reactNative.StyleSheet.flatten(style)
  }, hasInfinite ? content.balance.unlimited : formatRange(range))));
}
MoonDial.defaultProps = {
  size: 120,
  name: 'Dial',
  formatValue: function formatValue(value) {
    return value;
  },
  formatRange: function formatRange(value) {
    return value;
  }
};
MoonDial.propTypes = {
  value: _propTypes["default"].number.isRequired,
  range: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string,
  formal: _propTypes["default"].func
};